import { render, staticRenderFns } from "./ListRequestPage.vue?vue&type=template&id=04357f22"
import script from "./ListRequestPage.vue?vue&type=script&lang=js"
export * from "./ListRequestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports